export function escapeHtml(str: string): string {
  const lut: Record<string, string> = {
    ['<']: '&lt;',
    ['>']: '&gt;',
    ['"']: '&quot;',
    ["'"]: '&#39;',
  };

  return str.replace(/[<>&'"]/g, (c) => lut[c]);
}

export function capitalize(str: string): string {
  return str.charAt(0).toUpperCase() + str.slice(1);
}
